import React, { useState, useEffect } from "react";
import ChangeAlbeHeader from "./ChangeAbleHeader";
import makhana from "../assets/makhana-img.jpg";
import turmericPowder from "../assets/turmeric-powder-img.jpg";
import redChilliPowder from "../assets/red chilli-powder-img.jpg";
import corienderPowder from "../assets/coriender-powder-img.jpg";
import cuminPowder from "../assets/cumin-powder-img.jpg";
import gingerPowder from "../assets/ginger-powder-img.jpg";
import "../components/componentstyle/importCompo.css";

const productData = [
  {
    title: "MAKHANA",
    image: makhana,
    description:
      "Makhana is a wholesome superfood that blends taste with health. Often enjoyed roasted with a pinch of salt or spices, it’s an ideal guilt-free snack for all age groups. Its low glycemic index makes it suitable for diabetics, while its high antioxidant content supports skin health and aging. Whether you're fasting, dieting, or simply craving something crunchy, makhana is a smart and satisfying choice.",
    description2:
      "Makhana, or fox nuts, is a light and crunchy snack rich in protein, fiber, and minerals. Naturally low in calories and gluten-free, it's perfect for healthy snacking and supports digestion, heart health, and energy levels",
  },
  {
    title: "TURMERIC POWDER",
    image: turmericPowder,
    description:
      "Turmeric powder, derived from the dried roots of the Curcuma longa plant, is a vibrant yellow spice widely used in Indian cooking and traditional medicine. Known for its earthy flavor and warm aroma, turmeric adds color and depth to curries, soups, rice dishes, and more. It's a staple in kitchens around the world and is also used as a natural food coloring and preservative",
    description2:
      "Turmeric powder is a golden spice rich in curcumin, known for its anti-inflammatory and antioxidant benefits. It supports immunity, aids digestion, and promotes healthy skin naturally.",
  },
  {
    title: "RED CHILLI POWDER",
    image: redChilliPowder,
    description:
      "Red chilli powder is a vibrant and essential spice made from dried red chillies, widely used in Indian and global cuisines. It adds a fiery heat, rich color, and bold flavor to a variety of dishes like curries, chutneys, marinades, and snacks. Available in different heat levels, red chilli powder enhances taste while giving food its signature red hue.",
    description2:
      "Apart from its culinary value, red chilli powder also offers several health benefits. It is rich in vitamin C, capsaicin, and antioxidants, which help boost metabolism, improve digestion, and support immunity. Capsaicin is also known for its pain-relieving and anti-inflammatory properties. When used in moderation, red chilli powder not only spices up your meals but also contributes to overall wellness",
  },
  {
    title: "CORIANDER POWDER",
    image: corienderPowder,
    description:
      "Coriander powder, also known as dhania powder, is a staple spice in Indian and many global cuisines, made by grinding dried coriander seeds. It has a mild, earthy flavor with citrusy undertones, which adds depth and aroma to curries, dals, vegetables, and spice blends. Coriander powder enhances both the taste and the fragrance of food, making it an essential ingredient in everyday cooking.",
    description2:
      "Beyond its flavor, coriander powder offers several health benefits. It aids digestion, helps regulate blood sugar levels, and contains antioxidants that support overall health. Rich in dietary fiber, iron, and vitamins, it is also known to have anti-inflammatory and antibacterial properties. Coriander powder is not just a kitchen essential but a natural way to boost both flavor and wellness in your meals",
  },
  {
    title: "CUMIN POWDER",
    image: cuminPowder,
    description:
      "Cumin powder, also known as jeera powder, is a widely used spice made by grinding dried cumin seeds. It has a warm, earthy flavor with a slightly nutty and peppery aroma, making it a key ingredient in Indian, Middle Eastern, and Mexican cuisines. Whether added to curries, soups, rice, or spice blends, cumin powder enhances the overall depth and richness of dishes.",
    description2:
      "Cumin powder is also valued for its digestive and medicinal benefits. It helps stimulate enzyme production in the digestive tract, supports metabolism, and is rich in iron, antioxidants, and anti-inflammatory compounds. Traditionally used in Ayurvedic and home remedies, cumin powder is a flavorful way to promote gut health and boost overall wellness.",
  },
  {
    title: "GINGER POWDER",
    image: gingerPowder,
    description:
      "Ginger powder, made from dried and ground ginger root, is a versatile spice used in both culinary and medicinal applications. It has a warm, spicy-sweet flavor and is commonly used in Indian curries, masalas, teas, baked goods, and herbal remedies. Its concentrated aroma and taste make it an essential pantry ingredient for enhancing both sweet and savory dishes",
    description2:
      "Ginger powder is rich in antioxidants and has anti-inflammatory properties. It helps relieve nausea, aids digestion, reduces muscle pain, and boosts immunity. Commonly used in home remedies for colds, coughs, and throat issues..",
  },
];

function Importcompo({ title }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
    const timer = setTimeout(() => setAnimate(false), 500);
    return () => clearTimeout(timer);
  }, [activeIndex]);

  return (
    <>
      <div>
        <ChangeAlbeHeader>{title}</ChangeAlbeHeader>
      </div>

      <div className="product-wrapper container">
        <div className="product-list">
          {productData.map((item, index) => (
            <div
              key={index}
              className={`product-item ${
                activeIndex === index ? "active" : ""
              }`}
              onClick={() => setActiveIndex(index)}
            >
              <div className="circle-wrapper">
                <div className="circle-icon" />
              </div>
              <span className="text-uppercase">{item.title}</span>
            </div>
          ))}
        </div>

        <div className="product-content">
          <h3>{productData[activeIndex].title}</h3>

          <img
            src={productData[activeIndex].image}
            alt="product"
            className={animate ? "image-animate" : ""}
          />

          <p>{productData[activeIndex].description}</p>
          <p>{productData[activeIndex].description2}</p>
        </div>
      </div>
    </>
  );
}

export default Importcompo;
